/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react/macro';

import { Page, PagePanel } from 'components/Page';
import { StylingContextState } from 'context/Styling';
import { useStyles } from 'utils/useStyles';

import { MfaRecoveryForm } from './MfaRecoveryForm';

const getStyles = ({ colors }: StylingContextState) => ({
  content: css`
    #page-content {
      background-color: ${colors.white};
      box-shadow: 0px 32px 48px 0px rgba(0, 0, 0, 0.05) !important;
      width: 480px;

      @media (max-width: 768px) {
        margin: 24px;
        padding: 48px;
        width: 90%;
      }

      @media (max-width: 550px) {
        padding: 24px;
        max-width: 414px;
      }
    }
    #page-panels,
    #panel {
      width: 100%;

      @media (max-width: 768px) {
        padding: 0px;
        margin: 0px;
        width: 100%;
      }

      @media (max-width: 550px) {
        padding: 0 24px;
      }
    }
  `,
});

export const MfaRecovery = () => {
  const styles = useStyles(getStyles);

  return (
    <Page title="MFA Recovery" headingWidth="full" css={styles.content}>
      <PagePanel id="panel" type="full">
        <MfaRecoveryForm />
      </PagePanel>
    </Page>
  );
};
